// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimGroupViewSearchGroupViewSearchResponse {
    static getAttributeTypeMap() {
        return ClaimV1ClaimGroupViewSearchGroupViewSearchResponse.attributeTypeMap;
    }
}
ClaimV1ClaimGroupViewSearchGroupViewSearchResponse.discriminator = undefined;
ClaimV1ClaimGroupViewSearchGroupViewSearchResponse.additionalProperties = false;
ClaimV1ClaimGroupViewSearchGroupViewSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ClaimClaimGroupViewExtendedModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=claimV1ClaimGroupViewSearchGroupViewSearchResponse.js.map